import React from "react";
import VendorSwitchStats from "./vendor-switch-stats";
import { DATADOG_SWITCH_STATS } from "./datadog-comparison-data";
import type { SwitchStatsSection } from "./comparison-types";

type Props = {
  className?: string;
  content?: SwitchStatsSection;
};

/** @deprecated Prefer VendorSwitchStats with vendor data props */
const DatadogSwitchStats: React.FC<Props> = ({
  className = "",
  content = DATADOG_SWITCH_STATS,
}) => <VendorSwitchStats className={className} content={content} />;

export default DatadogSwitchStats;
